import { Form } from 'react-bootstrap';

const SapBw = ({ state, onChange }) => {
  const { client, name, synchronous, chain_restartable, sap_system } = state.config || {};

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-client">
        <Form.Label>Client</Form.Label>
        <Form.Control type="text" name="client" value={client || ''} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-name">
        <Form.Label>Name</Form.Label>
        <Form.Control type="text" name="name" value={name || ''} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-sap_system">
        <Form.Label>Sap System</Form.Label>
        <Form.Control type="text" name="sap_system" value={sap_system} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-synchronous">
        <Form.Check type="checkbox" name="synchronous" label="Synchronous" checked={!!synchronous} onChange={(e) => onChange(e, true)} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-chain_restartable">
        <Form.Check type="checkbox" name="chain_restartable" label="Chain restartable" checked={!!chain_restartable} onChange={(e) => onChange(e, true)} />
      </Form.Group>
    </>
  );
};

export default SapBw;
